import { render, staticRenderFns } from "./CommunityIntegrationForm.vue?vue&type=template&id=240c4714&scoped=true"
import script from "./CommunityIntegrationForm.vue?vue&type=script&lang=js"
export * from "./CommunityIntegrationForm.vue?vue&type=script&lang=js"
import style0 from "./CommunityIntegrationForm.vue?vue&type=style&index=0&id=240c4714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240c4714",
  null
  
)

export default component.exports